const doc = [({"da":({"js":({"merfoto":({"photo_session_group_contacts":({"select_album":({"choose_album":"Vælg album"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;